import { useQuery } from "@tanstack/react-query";
import type { LimitedUseRxNavQueryOptions, RxNavQueryRequests } from "./types";

export interface UseRxNavNormCodeQueryArgs<TError = Error, TData = RxNavQueryRequests["norm-code"]["response"]>
  extends LimitedUseRxNavQueryOptions<"norm-code", TError, TData> {}

export const useRxNavNormCodeQuery = <TError = Error, TData = RxNavQueryRequests["norm-code"]["response"]>({
  request,
  ...options
}: UseRxNavNormCodeQueryArgs<TError, TData>) =>
  useQuery({
    queryKey: ["rx-nav", "norm-code", request],
    queryFn: async () => {
      const url = encodeURI(`https://rxnav.nlm.nih.gov/REST/rxcui.json?name=${request.name}&allsrc=1`);
      const result = await fetch(url);
      return await result.json();
    },
    ...options,
  });
